/**
 * This file is the global include file. It is included on every page
 * in the front end.
 *
 * Include other files via `import` below.
 */
import './scripts/components/_site_disc';
import './scripts/components/_site_form';




// WEBPACK FOOTER //
// ./js/global.js